(function($) {
  $.cookie('LOCALE', 'en_US', { expires: -1, domain: '.bobbibrown.com.hk' });
})(jQuery);
